import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export function initAppInsights(connectionString: string) {
    if (!appInsights) {
        appInsights = new ApplicationInsights({
            config: {
                connectionString: connectionString,
                enableAutoRouteTracking: true,
                disableFetchTracking: false,
                enableAjaxErrorStatusText: true
            }
        });

        appInsights.loadAppInsights();
    }
}

export function trackTrace(message: string, properties?: Record<string, any>) {
    appInsights?.trackTrace({
        message,
        properties
    });
}

export function trackEvent(name: string, properties?: Record<string, any>) {
    appInsights?.trackEvent({
        name,
        properties
    });
}

export function trackException(error: Error, properties?: Record<string, any>) {
    appInsights?.trackException({
        exception: error,
        properties
    });
}
